<script lang="ts" setup>
import { nextTick, onMounted, ref } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { getMyCountdownList } from '~/api/oj/my';
import IconArrow from '~/components/IconArrow.vue';
import { StorageService } from '~/services/storage.service';
import ContestCountdownItem from './ContestCountdownItem.vue';

const storageService = useService(StorageService);
const visible = ref(true);
const carouselRef = ref();
const list = ref([] as any[]);

function handleAfterChange(cur: number) {
  if (list.value && list.value[cur]) {
    const id = list.value[cur].id;
    storageService.setDefaultCountdown(id);
  }
}

function initDefaultValue() {
  const id = storageService.getDefaultCountdown() || 0;
  if (id && list.value) {
    const index = list.value.findIndex((item) => item.id === id);
    if (index > 0) {
      nextTick(() => {
        carouselRef.value.goTo(index, true);
      });
    }
  }
}

function init() {
  getMyCountdownList()
    .then((res) => {
      if (res.length > 0) {
        list.value = res;
        initDefaultValue();
      } else {
        visible.value = false;
      }
    })
    .catch(() => {
      visible.value = false;
    });
}

onMounted(() => {
  init();
});
</script>

<template>
  <div
    v-if="visible"
    class="relative overflow-hidden rounded border border-lightblack bg-white"
  >
    <div
      v-if="list.length === 0"
      class="flex h-[123px] items-center justify-center p-3"
    >
      <a-skeleton />
    </div>
    <a-carousel
      v-else
      ref="carouselRef"
      arrows
      :dots="false"
      :infinite="false"
      :after-change="handleAfterChange"
    >
      <template #prevArrow>
        <IconArrow class="!left-2.5 z-10 !h-7 !w-7 rotate-180" />
      </template>
      <template #nextArrow>
        <IconArrow class="!right-2.5 !h-7 !w-7" />
      </template>

      <ContestCountdownItem
        v-for="item in list"
        :key="item.id"
        v-track:newoj_homepage_countdown_show="{ contest_id: item.id }"
        :data="item"
      />
    </a-carousel>
  </div>
</template>

<style scoped>
:deep(.slick-arrow.slick-disabled) {
  opacity: 0.3;
  @apply cursor-not-allowed;
}
</style>
